import { COMPANY } from "@/components/legal/LegalPage";

const C = { ...COMPANY, address: COMPANY.address.replace("Svizzera", "Switzerland") };

export const PRIVACY_EN = [
  { title: "Data controller", body: [
    `The data controller is ${C.name}, ${C.address}, UID ${C.uid}. For any data protection request: ${C.email}.`,
    "For data subjects in the EU, where required by art. 27 GDPR, the controller will appoint a representative in the Union, whose details will be published on this page.",
  ] },
  { title: "Applicable law", body: [
    "This notice is provided under the Swiss Federal Act on Data Protection (FADP, in force since 1 September 2023) and its ordinance (DPO), and, for users in the European Union, Regulation (EU) 2016/679 (GDPR).",
  ] },
  { title: "Data collected", body: [
    { list: [
      "Account data: name, email, mobile number, password (stored hashed), role.",
      "Access and device data: IP address, operating system and browser at sign-up and last login, for security and fraud prevention.",
      "Messages exchanged with our team via the reserved-area chat.",
      "Order and billing data: purchased campaigns, amounts, currency, discount codes, payment status, invoices. Card data is processed directly by Stripe.",
      "Campaign configuration data: website URL, location, sector/skill, notes, target, budget and duration.",
      "Acceptance of Terms and Privacy Policy: date, time and document version.",
      "Technical data: IP address, browser, access and security logs.",
      "Communications: emails and messages exchanged with our team.",
    ] },
  ] },
  { title: "Purposes and legal bases", body: [
    { list: [
      "Performance of contract (art. 6(1)(b) GDPR): account, orders, campaigns, reports, invoices and support.",
      "Legal obligations (art. 6(1)(c) GDPR): accounting, tax, document retention.",
      "Legitimate interest (art. 6(1)(f) GDPR): platform security, fraud prevention, service improvement, service communications.",
      "Consent (art. 6(1)(a) GDPR): any marketing communications and non-essential cookies, revocable at any time.",
    ] },
    "Under the FADP, processing complies with the principles of lawfulness, good faith, proportionality, purpose limitation and transparency (art. 6 FADP).",
  ] },
  { title: "Third-party data in campaign reports", body: [
    "As part of campaigns, the Provider collects public social profiles and publicly available business contact data (e.g. business name, address, website, phone) relevant to the target chosen by the Customer, based on legitimate interest.",
    `Such data is made available to the Customer, who uses it as independent controller and is responsible for compliance in any subsequent contact. Data subjects may object by writing to ${C.email}.`,
  ] },
  { title: "Recipients and processors", body: [
    "Data may be shared with providers acting as processors under contract:",
    { list: [
      "Stripe Payments Europe Ltd. — payment processing.",
      "Hosting and cloud infrastructure providers — platform delivery.",
      "Transactional email provider (e.g. Resend) — notifications, invoices and reports.",
      "Artificial intelligence service providers — SEO suggestions (no payment data).",
      "Advertising platforms (e.g. Meta, Google, TikTok) — campaign execution.",
    ] },
    "Data is never sold to third parties.",
  ] },
  { title: "International transfers", body: [
    "Some providers may process data outside Switzerland and the EEA (e.g. USA). Transfers take place to countries with an adequate level of protection as recognised by the Swiss Federal Council / EU Commission (e.g. Swiss-U.S. and EU-U.S. Data Privacy Framework) or on the basis of Standard Contractual Clauses approved and recognised by the FDPIC.",
  ] },
  { title: "Retention", body: [
    { list: [
      "Account data: for the duration of the relationship and up to 24 months after account closure.",
      "Accounting and billing data: 10 years (art. 958f Swiss CO).",
      "Reports and campaign data: up to 24 months after campaign end, unless earlier deletion is requested.",
      "Technical and security logs: up to 12 months.",
    ] },
  ] },
  { title: "Security", body: [
    "We apply appropriate technical and organisational measures (art. 8 FADP, art. 32 GDPR): HTTPS encryption, hashed passwords, role-based access control, access logging and backups. In case of a data breach likely to result in a high risk, we will notify the FDPIC, the competent authorities and the data subjects as required by law.",
  ] },
  { title: "Your rights", body: [
    "You have the right to access (art. 25 FADP, art. 15 GDPR), rectification, erasure, restriction, objection, data portability (art. 28 FADP, art. 20 GDPR) and to withdraw consent at any time, without affecting the lawfulness of prior processing.",
    `To exercise them, write to ${C.email}. We normally reply within 30 days. You may also lodge a complaint with the Swiss Federal Data Protection and Information Commissioner (FDPIC, www.edoeb.admin.ch) or the supervisory authority of your EU country of residence.`,
    "We do not carry out automated individual decisions producing legal effects concerning you.",
  ] },
  { title: "Visitor tracking (with consent)", body: [
    "Only if you accept analytics cookies in the banner do we record browsing data for statistics and security: anonymised IP address (last octet zeroed), user agent, operating system, browser, device type, pages visited, session duration, referrer, date and time, and approximate country and city derived from the IP.",
    "Legal basis: your consent (art. 6(1)(a) GDPR; art. 6(6) FADP), revocable at any time via the \"Cookie preferences\" link in the footer. Data are kept for a maximum of 90 days and then deleted automatically (auto-deleting).",
    "Your phone number is never collected automatically by the browser: we only process it if you enter it voluntarily in a form (contact, chat, checkout).",
  ] },
  { title: "Cookie Policy", body: [
    "We use necessary technical cookies (always active), analytics cookies (only with consent) and, if introduced in the future, marketing cookies (only with consent). The full list with name, purpose, duration and provider is on the Cookie Policy page (/cookie-policy).",
    "You can change your choices at any time via the \"Cookie preferences\" link in the footer or delete cookies in your browser settings.",
  ] },
  { title: "Minors", body: [
    "The Service is intended for persons aged 18 or over. We do not knowingly collect data from minors.",
  ] },
  { title: "Changes to this notice", body: [
    "This notice may be updated. The current version is always published on this page with the last update date; material changes will be communicated to registered users.",
  ] },
  { title: "Contact", body: [
    `To exercise your rights or for any privacy question write to ${C.email}. We reply within 30 days.`,
    `Postal address: ${C.name}, ${C.notices}.`,
  ] },
];
